import React from 'react'
import Select from 'react-select'

import {
  WEEKDAYS,
  DAY_OFFSETS,
  formatPreview,
  validateSlot,
} from './scheduleSlot'

function findOption(options, value) {
  return options.find(o => o.value === value) || options[0]
}

function ScheduleSlotEditor({ slot, menus, index, onChange, onRemove }) {
  const errors = validateSlot(slot)
  const preview = formatPreview(slot)

  const update = patch => onChange({ ...slot, ...patch })

  return (
    <div className="schedule-day-box">
      <div className="schedule-slot-header">
        <span className="schedule-slot-title">Slot {index + 1}</span>
        <span
          className="options-menu-allerg-section-remove"
          onClick={onRemove}
          title="Rimuovi slot"
        >
          X
        </span>
      </div>

      <div className="new-allergene-item menu-inline-selection">
        <span className="section-title-span">Nome: </span>
        <input
          type="text"
          value={slot.name || ''}
          onChange={e => update({ name: e.target.value })}
          placeholder="es. Pranzo lunedì"
        />
      </div>

      <div className="new-allergene-item menu-inline-selection">
        <span className="section-title-span">Menu: </span>
        <span className="section-select-span">
          <Select
            value={{ label: slot.menuName || '', value: slot.menu || '' }}
            onChange={e => update({ menu: e.value, menuName: e.label })}
            options={menus}
          />
        </span>
      </div>

      <div className="schedule-slot-row">
        <span className="section-title-span">Consegna: </span>
        <span className="schedule-slot-day">
          <Select
            value={findOption(WEEKDAYS, slot.weekday)}
            onChange={e => update({ weekday: e.value })}
            options={WEEKDAYS}
          />
        </span>
        <span className="schedule-slot-at">alle</span>
        <input
          type="time"
          step="900"
          value={slot.deliverAt || '12:00'}
          onChange={e => update({ deliverAt: e.target.value })}
        />
      </div>

      <div className="schedule-slot-row">
        <span className="section-title-span">Apertura ordini: </span>
        <span className="schedule-slot-day">
          <Select
            value={findOption(DAY_OFFSETS, slot.openOffset)}
            onChange={e => update({ openOffset: e.value })}
            options={DAY_OFFSETS}
          />
        </span>
        <span className="schedule-slot-at">alle</span>
        <input
          type="time"
          step="900"
          value={slot.openAt || '19:00'}
          onChange={e => update({ openAt: e.target.value })}
        />
      </div>

      <div className="schedule-slot-row">
        <span className="section-title-span">Chiusura ordini: </span>
        <span className="schedule-slot-day">
          <Select
            value={findOption(DAY_OFFSETS, slot.closeOffset)}
            onChange={e => update({ closeOffset: e.value })}
            options={DAY_OFFSETS}
          />
        </span>
        <span className="schedule-slot-at">alle</span>
        <input
          type="time"
          step="900"
          value={slot.closeAt || '09:30'}
          onChange={e => update({ closeAt: e.target.value })}
        />
      </div>

      <div className="schedule-slot-preview">
        <span className="schedule-slot-preview-label">Riepilogo:</span>{' '}
        {preview}
        <span className="schedule-slot-tz"> (Europe/Rome)</span>
      </div>

      {errors.length > 0 && (
        <ul className="schedule-slot-errors">
          {errors.map((e, i) => (
            <li key={i}>{e}</li>
          ))}
        </ul>
      )}

      {slot._legacyImported && (
        <div className="schedule-slot-warning">
          ⚠ Configurazione importata dal vecchio formato. Verifica gli orari
          prima di salvare.
        </div>
      )}
    </div>
  )
}

export default ScheduleSlotEditor
